import { apiClient } from './apiClient';

export type ServiceSupportAnalyticsSlice = {
  label: string;
  count: number;
};

export type ServiceSupportAnalyticsSummary = {
  totalTickets: number;
  openTickets: number;
  incidentCount: number;
  requestCount: number;
  resolvedCount: number;
  meanTimeToResolveMinutes: number;
  meanTimeToFirstResponseMinutes: number;
  slaResponseCompliancePercent: number;
  slaResolutionCompliancePercent: number;
};

export type ServiceSupportAnalytics = {
  summary: ServiceSupportAnalyticsSummary;
  byStatus: ServiceSupportAnalyticsSlice[];
  byType: ServiceSupportAnalyticsSlice[];
  byCatalogItem: ServiceSupportAnalyticsSlice[];
  generatedAtUtc: string;
};

export async function fetchSupportAnalytics(): Promise<ServiceSupportAnalytics> {
  const response = await apiClient.get<ServiceSupportAnalytics>('/v1/customer-success/analytics');
  return response.data;
}
